import { useEffect, useState } from "react";

/**
 * Tracks whether the viewport width is below a mobile breakpoint.
 * Defaults to 768px to match the app's existing mobile cutoff (see CalendarView).
 *
 * This is width-based, not UA-based — a narrow desktop window will also be
 * treated as mobile, matching the behavior users get when resizing their window.
 */
export function useIsMobile(breakpoint = 768): boolean {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth < breakpoint : false,
  );

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const handleChange = () => setIsMobile(mql.matches);
    handleChange();
    mql.addEventListener("change", handleChange);
    return () => mql.removeEventListener("change", handleChange);
  }, [breakpoint]);

  return isMobile;
}
